var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertTemplateBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.461,
    height: 18.125,
    viewBox: "0 0 17.461 18.125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "risk-management_1_",
    "data-name": "risk-management (1)",
    transform: "translate(-92.818 -9.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1581",
    "data-name": "Group 1581",
    transform: "translate(93.515 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1580",
    "data-name": "Group 1580",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M108.464,19.305a1.283,1.283,0,0,1,0-1.786l.757-.78a1.282,1.282,0,0,0,.19-1.534l-1.153-2a1.282,1.282,0,0,0-1.424-.6l-1.055.265a1.283,1.283,0,0,1-1.546-.894l-.3-1.045A1.285,1.285,0,0,0,102.7,10h-2.307a1.284,1.284,0,0,0-1.234.932l-.3,1.045a1.283,1.283,0,0,1-1.546.894l-1.055-.265a1.283,1.283,0,0,0-1.423.6l-1.153,2a1.281,1.281,0,0,0,.19,1.534l.757.78a1.283,1.283,0,0,1,0,1.786l-.757.781a1.282,1.282,0,0,0-.19,1.534l1.153,2a1.282,1.282,0,0,0,1.423.6l1.055-.265a1.283,1.283,0,0,1,1.546.894l.3,1.045a1.284,1.284,0,0,0,1.234.932H102.7a1.285,1.285,0,0,0,1.234-.932l.3-1.045a1.283,1.283,0,0,1,1.546-.894l1.055.265a1.283,1.283,0,0,0,1.424-.6l1.153-2a1.282,1.282,0,0,0-.19-1.534Z",
    transform: "translate(-93.515 -10)",
    fill: "none",
    stroke: "#42687b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M154.3,66.189l-3.536,6.125a1.328,1.328,0,0,0,1.15,1.992h7.072a1.328,1.328,0,0,0,1.15-1.992L156.6,66.189A1.328,1.328,0,0,0,154.3,66.189Z",
    transform: "translate(-53.905 -52.443)",
    fill: "none",
    stroke: "#e85257",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    y2: 2.112,
    transform: "translate(101.549 15.735)",
    fill: "none",
    stroke: "#e85257",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    transform: "translate(101.549 19.729)",
    fill: "none",
    stroke: "#e85257",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTemplateBlue);
export default __webpack_public_path__ + "static/media/AlertTemplateBlue.edc5e89d549079b5077aad1d721b1bd7.svg";
export { ForwardRef as ReactComponent };